import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import "@/extensions/number.extensions";
import DataTable from "@/components/layout/DataTable.vue"
import Card from "@/components/layout/Card.vue"
import { useI18n } from "vue3-i18n"
import { Invoice } from "@/types/entities/invoice"
import { computed } from "vue";

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceTable',
  props: {
    invoices: {},
    isLoading: { type: Boolean },
    title: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n()

const formattedInvoices = computed(() => {
    return [...props.invoices]
    .sort((a: Invoice, b: Invoice) => new Date(b.createdAt ?? "").valueOf() - new Date(a.createdAt ?? "").valueOf())
    .map(x => {
        return {
            description : x.description,
            accountingSoftwareNumber: x.accountingSoftwareNumber,
            createdAt: x.createdAt,
            total: x.total?.toCurrency(),
            isPaid: x.total == 0 ? t("global.free") : t(x.isPaid ? 'global.yes' : 'global.no'),
            actions: {
              bill : x.accountingSoftwareUrl,
            }
        };
    })
})

const invoiceHeader = [
    {
        text: t("invoice.accountingSoftwareNumber"),
        value: "accountingSoftwareNumber",
        sortable: true,
    },
    {
        text: t("invoice.description"),
        value: "description",
        sortable: true,
    },
    {
        text: t("invoice.creationDate"),
        value: "createdAt",
        sortable: true,
    },
    {
        text: t("invoice.isPaid"),
        value: "isPaid",
        sortable: true,
    },
    {
        text: t("invoice.total"),
        value: "total",
        sortable: true,
        width: 100,
    },
    {
        text: t("global.table.actions"),
        value: "actions",
        sortable: false,
        width: 75
    }
]


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, {
    title: _ctx.title ?? _unref(t)('global.invoices')
  }, {
    default: _withCtx(() => [
      _createVNode(DataTable, {
        headers: invoiceHeader,
        items: formattedInvoices.value,
        "is-loading": _ctx.isLoading
      }, null, 8, ["items", "is-loading"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})